import React from "react";
import ReactDOM from "react-dom/client";
// import ".../../../packages/shared-ui";
import "react-toastify/dist/ReactToastify.css";
import "./styles/toast.css";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

